(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase()
      .trim();
  }

  function tokens(value) {
    return normalize(value).split(/\s+/).filter(Boolean);
  }

  function matches(item, query, topic) {
    if (topic && topic !== 'all' && item.topic !== topic) return false;
    var searchable = normalize((item.title || '') + ' ' + (item.tags || ''));
    return tokens(query).every(function (token) { return searchable.includes(token); });
  }

  function uniqueItems(items, getKey) {
    var keys = new Set();
    return items.filter(function (item) {
      var key = getKey(item);
      if (!key || keys.has(key)) return false;
      keys.add(key);
      return true;
    });
  }

  function searchHistoryAction(action, edited, nextValue, currentValue) {
    if (action === 'edit') return edited ? 'replace' : 'push';
    if (action === 'submit') return edited || String(nextValue || '') === String(currentValue || '') ? 'none' : 'push';
    return 'reset';
  }

  function initialVisibleCount(search, pageSize) {
    var query = String(search || '');
    var params = new URL('https://hcs-blog-hub.invalid/' + (query.charAt(0) === '?' ? query : '?' + query)).searchParams;
    var requested = Number.parseInt(params.get('shown') || '', 10);
    var currentPage = Number.parseInt(params.get('page') || '1', 10) || 1;
    return requested > 0 ? requested : Math.max(pageSize, currentPage * pageSize);
  }

  async function aggregatePages(firstUrl, fetchPage, getKey) {
    var items = [];
    var visited = new Set();
    var url = firstUrl;

    while (url) {
      if (visited.has(url)) throw new Error('The article archive returned a repeated page.');
      visited.add(url);
      var page = await fetchPage(url);
      if (!page || !Array.isArray(page.items)) throw new Error('The article archive page could not be read.');
      items = items.concat(page.items);
      url = page.nextUrl || null;
    }

    return uniqueItems(items, getKey);
  }

  var api = { normalize: normalize, tokens: tokens, matches: matches, uniqueItems: uniqueItems, aggregatePages: aggregatePages, searchHistoryAction: searchHistoryAction, initialVisibleCount: initialVisibleCount };
  if (typeof window !== 'undefined') window.HCSBlogHub = api;
  if (typeof document === 'undefined') return;

  var root = document.querySelector('[data-hbh-section]');
  if (!root) return;

  var form = root.querySelector('[data-hbh-search-form]');
  var input = root.querySelector('[data-hbh-search-input]');
  var topics = root.querySelector('[data-hbh-topics]');
  var grid = root.querySelector('[data-hbh-grid]');
  var status = root.querySelector('[data-hbh-status]');
  var empty = root.querySelector('[data-hbh-empty]');
  var pagination = root.querySelector('[data-hbh-pagination]');
  var loadMore = root.querySelector('[data-hbh-load-more]');
  var fallback = root.querySelector('[data-hbh-fallback]');
  var allCards = null;
  var loading = null;
  var loadFailed = false;
  var submitAfterLoad = false;
  var searchEditSession = false;
  var activeTopic = 'all';
  var visibleCount = 18;

  function cardsIn(node) {
    return Array.prototype.map.call(node.querySelectorAll('[data-hbh-card]'), function (card) {
      return {
        element: card,
        url: card.querySelector('.hbh-card__link') && card.querySelector('.hbh-card__link').getAttribute('href'),
        topic: card.getAttribute('data-hbh-topic') || 'stories',
        title: card.getAttribute('data-hbh-title') || '',
        tags: card.getAttribute('data-hbh-tags') || '',
        handle: card.getAttribute('data-hbh-handle') || ''
      };
    });
  }

  function pageUrl(url) {
    var target = new URL(url, window.location.href);
    preservePreviewParams(target);
    target.searchParams.set('section_id', root.getAttribute('data-section-id'));
    target.searchParams.delete('topic');
    target.searchParams.delete('q');
    target.searchParams.delete('shown');
    return target.toString();
  }

  function firstPageUrl() {
    var target = new URL(window.location.href);
    target.searchParams.set('page', '1');
    target.searchParams.set('section_id', root.getAttribute('data-section-id'));
    target.searchParams.delete('topic');
    target.searchParams.delete('q');
    target.searchParams.delete('shown');
    return target.toString();
  }

  function preservePreviewParams(target) {
    var current = new URL(window.location.href);
    current.searchParams.forEach(function (value, key) {
      if ((key.indexOf('preview') === 0 || key === '_fd') && !target.searchParams.has(key)) {
        target.searchParams.set(key, value);
      }
    });
  }

  async function fetchPage(url) {
    var response = await window.fetch(pageUrl(url), { credentials: 'same-origin', headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('Article archive request failed with ' + response.status);
    var html = await response.text();
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var pageRoot = parsed.querySelector('[data-hbh-section]');
    if (!pageRoot) throw new Error('The article archive section was missing from the response.');
    return {
      items: cardsIn(pageRoot),
      nextUrl: pageRoot.getAttribute('data-next-url') || null
    };
  }

  function articleKey(card) {
    if (!card.url) return '';
    var url = new URL(card.url, window.location.href);
    url.search = '';
    url.hash = '';
    return url.pathname.replace(/\/$/, '');
  }

  function readState() {
    var params = new URL(window.location.href).searchParams;
    return {
      topic: params.get('topic') || 'all',
      query: params.has('q') ? params.get('q') : '',
      shown: initialVisibleCount(window.location.search, 18)
    };
  }

  function writeState(method, resetPage) {
    var url = new URL(window.location.href);
    if (activeTopic === 'all') url.searchParams.delete('topic');
    else url.searchParams.set('topic', activeTopic);
    if (input.value.trim()) url.searchParams.set('q', input.value.trim());
    else url.searchParams.delete('q');
    if (visibleCount > 18) url.searchParams.set('shown', String(visibleCount));
    else url.searchParams.delete('shown');
    if (resetPage) url.searchParams.delete('page');
    window.history[method + 'State']({ hbh: true }, '', url.toString());
  }

  function setControls(state) {
    activeTopic = ['all', 'cook', 'choose', 'nutrition', 'stories'].indexOf(state.topic) >= 0 ? state.topic : 'all';
    input.value = state.query;
    visibleCount = Math.max(18, state.shown || 18);
    Array.prototype.forEach.call(topics.querySelectorAll('[data-topic]'), function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-topic') === activeTopic ? 'true' : 'false');
    });
  }

  function render() {
    var filtered = allCards.filter(function (card) { return matches(card, input.value, activeTopic); });
    var shownCards = filtered.slice(0, visibleCount);
    var fragment = document.createDocumentFragment();
    shownCards.forEach(function (card) { fragment.appendChild(card.element.cloneNode(true)); });
    grid.replaceChildren(fragment);
    empty.hidden = filtered.length > 0;
    loadMore.hidden = filtered.length <= shownCards.length;
    pagination.hidden = true;
    status.textContent = filtered.length
      ? 'Showing ' + shownCards.length + ' of ' + filtered.length + ' articles.'
      : 'No articles match those filters.';
  }

  function renderMore(previousCount, keyboardActivation) {
    var filtered = allCards.filter(function (card) { return matches(card, input.value, activeTopic); });
    var newCards = filtered.slice(previousCount, visibleCount);
    var fragment = document.createDocumentFragment();
    newCards.forEach(function (card) { fragment.appendChild(card.element.cloneNode(true)); });
    grid.appendChild(fragment);
    empty.hidden = filtered.length > 0;
    loadMore.hidden = filtered.length <= visibleCount;
    status.textContent = 'Showing ' + Math.min(visibleCount, filtered.length) + ' of ' + filtered.length + ' articles.';
    if (keyboardActivation && newCards.length) {
      var firstNewCard = grid.querySelectorAll('[data-hbh-card]')[previousCount];
      var firstNewLink = firstNewCard && firstNewCard.querySelector('.hbh-card__link');
      if (firstNewLink) firstNewLink.focus();
    }
  }

  function commitSearch() {
    var currentQuery = new URL(window.location.href).searchParams.get('q') || '';
    var action = searchHistoryAction('submit', searchEditSession, input.value.trim(), currentQuery);
    searchEditSession = false;
    if (action !== 'none') writeState(action, true);
  }

  function ensureLibrary() {
    if (allCards) return Promise.resolve(allCards);
    if (loading) return loading;
    topics.hidden = false;
    fallback.hidden = true;
    loadFailed = false;
    status.textContent = 'Finding articles…';
    var first = firstPageUrl();
    loading = aggregatePages(first, fetchPage, articleKey)
      .then(function (cards) {
        if (!cards.length) throw new Error('The article archive did not contain any articles.');
        allCards = cards;
        pagination.hidden = true;
        setControls(readState());
        render();
        loadFailed = false;
        if (submitAfterLoad) {
          submitAfterLoad = false;
          commitSearch();
        }
        return cards;
      })
      .catch(function () {
        loadFailed = true;
        submitAfterLoad = false;
        fallback.hidden = false;
        status.textContent = 'Could not load all articles. Try again or browse by page.';
        pagination.hidden = false;
        return null;
      })
      .finally(function () { loading = null; });
    return loading;
  }

  topics.hidden = false;
  setControls(readState());
  status.textContent = 'Browse articles newest first.';

  form.addEventListener('submit', function (event) {
    if (!allCards && loadFailed) return;
    event.preventDefault();
    if (!allCards) {
      submitAfterLoad = true;
      var currentQuery = new URL(window.location.href).searchParams.get('q') || '';
      var action = searchHistoryAction('edit', searchEditSession, input.value.trim(), currentQuery);
      searchEditSession = true;
      writeState(action, true);
      ensureLibrary();
      return;
    }
    var currentQuery = new URL(window.location.href).searchParams.get('q') || '';
    if (input.value.trim() !== currentQuery) visibleCount = 18;
    render();
    commitSearch();
  });

  input.addEventListener('input', function () {
    visibleCount = 18;
    var currentQuery = new URL(window.location.href).searchParams.get('q') || '';
    var action = searchHistoryAction('edit', searchEditSession, input.value.trim(), currentQuery);
    searchEditSession = true;
    writeState(action, true);
    if (allCards) render();
    else ensureLibrary();
  });

  topics.addEventListener('click', function (event) {
    var button = event.target.closest('[data-topic]');
    if (!button) return;
    activeTopic = button.getAttribute('data-topic');
    searchEditSession = false;
    visibleCount = 18;
    setControls({ topic: activeTopic, query: input.value, shown: 18 });
    writeState('push', true);
    if (allCards) render();
    else ensureLibrary();
  });

  loadMore.addEventListener('click', function (event) {
    searchEditSession = false;
    var previousCount = visibleCount;
    visibleCount += 18;
    renderMore(previousCount, event.detail === 0);
    writeState('push', true);
  });

  root.querySelector('[data-hbh-reset]').addEventListener('click', function () {
    searchEditSession = false;
    setControls({ topic: 'all', query: '', shown: 18 });
    render();
    writeState('push', true);
    input.focus();
  });

  root.querySelector('[data-hbh-retry]').addEventListener('click', function (event) {
    if (event.detail === 0) input.focus();
    fallback.hidden = true;
    loadFailed = false;
    ensureLibrary();
  });

  window.addEventListener('popstate', function () {
    searchEditSession = false;
    var state = readState();
    setControls(state);
    visibleCount = state.shown;
    if (allCards) render();
    else ensureLibrary();
  });

  var initialParams = new URL(window.location.href).searchParams;
  if (initialParams.has('topic') || initialParams.has('q') || initialParams.has('shown') || Number(root.getAttribute('data-current-page')) > 1) {
    ensureLibrary();
  }
}());
